/**
 * Lets a page's own scroll-restoration layout effect suppress App.js's
 * global "reset scroll to top on route change" for the commit where it's
 * restoring a saved position (see OfflineHotelsPage.js). React runs layout
 * effects child-before-parent within a single commit, so a page can claim
 * here before App.js's own layout effect checks it — a plain module-level
 * flag is safe because nothing else can interleave in that window.
 *
 * The claim expires almost immediately: it is only ever meaningful within
 * the single commit it was made in. A claim made in a commit App.js never
 * checks (a query-string-only navigation doesn't change `pathname`, so its
 * effect doesn't run) used to survive until the NEXT pathname change and
 * silently cancel that page's scroll-to-top — Home opened scrolled halfway
 * down because the reader had re-entered a city card minutes earlier.
 */
let claimedAt = 0;

const CLAIM_TTL_MS = 1000;

export function claimScrollRestore() {
  claimedAt = Date.now();
}

export function consumeScrollRestoreClaim() {
  const fresh = claimedAt && (Date.now() - claimedAt) < CLAIM_TTL_MS;
  claimedAt = 0;
  return fresh;
}
